import { load, save } from '../lib/storage.ts';

/**
 * What this device keeps per challenge: the token that proves it is this player (one
 * game per device), and an answer sent but not confirmed yet, so a reload or a lost
 * connection never loses it (it is resent with the same idempotency key).
 */

export interface DeviceGame {
  token: string;
  nickname: string;
}

export interface PendingAnswer {
  position: number;
  choice: number | null;
  idempotency_key: string;
}

const gameKey = (code: string) => `cruz.reto.${code}`;
const pendingKey = (code: string) => `cruz.reto.${code}.pending`;

export const loadGame = (code: string): DeviceGame | null =>
  load<DeviceGame | null>(gameKey(code), null);
export const saveGame = (code: string, game: DeviceGame): void => save(gameKey(code), game);

export const loadPending = (code: string): PendingAnswer | null =>
  load<PendingAnswer | null>(pendingKey(code), null);
export const savePending = (code: string, p: PendingAnswer | null): void => {
  if (p) save(pendingKey(code), p);
  else {
    try {
      localStorage.removeItem(pendingKey(code));
    } catch {
      // Storage blocked: nothing to remove
    }
  }
};

export function newIdempotencyKey(): string {
  const bytes = new Uint8Array(12);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
}
